/**
 * The questionnaire's Flagsmith flags. `fe_ez_file_new_ui` and
 * `show_new_feature_v1` were retired in October 2026: both A/B tests were
 * decided for the new side, which is now plain code.
 */
export const FLAGSMITH_KEYS = {
  /** Whether the customer chat widget is shown, where the build allows chat. */
  CHAT: 'fe_chat_enabled',
} as const;

export type QuestionnaireFlagKey = (typeof FLAGSMITH_KEYS)[keyof typeof FLAGSMITH_KEYS];
